import styled from 'styled-components';

interface CustomRadioProps {
  disabled?: boolean;
  checked?: boolean;
}

export const CustomRadio = styled.span<CustomRadioProps>(({ checked, theme }) => ({
  backgroundColor: checked ? theme.colors.primary['500'] : theme.colors.bg,
  borderRadius: '50%',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: theme.colors.neutral['300'],
  height: 16,
  width: 16,
  boxSizing: 'border-box',
  display: 'inline-block',
  position: 'relative',
  transition: `background-color ${theme.transitions.normal}, border-color ${theme.transitions.normal}, box-shadow ${theme.transitions.normal}`,
  boxShadow: checked ? theme.shadows['-100'] : theme.shadows['100'],

  '@media print': {
    transition: 'none',
    boxShadow: 'none',
  },

  '&:after': {
    content: checked ? '""' : '',
    position: 'absolute',
    borderRadius: '50%',
    backgroundColor: theme.colors.bg,
    opacity: 0,
    top: 4,
    left: 4,
    width: 6,
    height: 6,
    transition: `opacity ${theme.transitions.normal}`,
  },

  '&:hover': {
    backgroundColor: checked ? theme.colors.primary['500'] : theme.colors.neutral['100'],
    boxShadow: checked ? theme.shadows['-100'] : theme.shadows['300'],
  },
}));

interface StyledInputProps {
  hideFocus: boolean;
}

export const StyledInput = styled.input<StyledInputProps>(({ theme, hideFocus }) => ({
  position: 'absolute',
  opacity: 0,
  cursor: 'pointer',
  height: 0,
  width: 0,

  '&[data-focus-visible-added]:focus': {
    [`& ~ ${CustomRadio}`]: {
      outline: 'none',
      ...(!hideFocus
        ? {
            boxShadow: `0 0 0 2px ${theme.colors.primary['300']}`,
            borderColor: theme.colors.primary['500'],
          }
        : {}),
    },
  },

  '&:disabled': {
    [`& ~ ${CustomRadio}`]: {
      backgroundColor: theme.colors.neutral['300'],
      boxShadow: 'none',
    },
  },

  '&:checked': {
    [`~ ${CustomRadio}`]: {
      borderColor: theme.colors.primary['500'],

      '&:after': {
        opacity: 1,
      },
    },

    '&:disabled': {
      [`& ~ ${CustomRadio}`]: {
        backgroundColor: theme.colors.primary['300'],
        borderColor: theme.colors.primary['300'],
      },
    },
  },
}));
